import ArticleCard from '@/components/base/ArticleCard';
import { featuredArticles } from '@/mocks/articles';

export default function LatestArticles() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-sm font-medium rounded-full mb-3">
              最新资讯
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              深夜生活指南
            </h2>
          </div>
          <a
            href="/articles"
            className="inline-flex items-center gap-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            查看全部文章
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {featuredArticles.map((article) => (
            <ArticleCard
              key={article.id}
              id={article.id}
              title={article.title}
              summary={article.summary}
              imageUrl={article.imageUrl}
              date={article.date}
              readTime={article.readTime}
            />
          ))}
        </div>
      </div>
    </section>
  );
}